// Module
var code = `<div id="file-upload" class="file-upload">
    <div class="alert alert--danger" ng-if="\$ctrl.exceededFileLimit()">
      Too many files uploaded. Max: {{\$ctrl.maxFiles}}
    </div>

    <ol class="file-upload__list">
        <li ng-repeat="item in \$ctrl.ngModel.\$modelValue" class="file-upload__list-item">
            <figure class="file-upload__image">
                <img ng-src="{{item.thumbnail}}"
                     ng-if="\$ctrl.isImage(item)"
                     class="file-upload__thumbnail file-upload__thumbnail--zoomed-out"
                     data-flip-key="{{item.id}}"
                />
                <div ng-if="!\$ctrl.isImage(item)"
                   ng-click="\$ctrl.downloadFile(item)"
                   class="file-upload__thumbnail--download"
                >
                  <i class="icon-download icon-white"></i>
                </div>
                <figcaption ng-show="\$ctrl.displayFileName(item)" class="file-upload__caption">{{item.fileName}}</figcaption>
                <div class="file-upload__progressbar" ng-show="item.progress >= 0 && !item.uploaded">
                  <div
                    class="file-upload__progressbar-value"
                    ng-style="{width: item.progress}">
                  </div>
                </div>
            </figure>
            <div class="file-upload__input-container">
              <div class="labelled-field" ng-show="\$ctrl.showRemarks">
                <label for="remarks">Remarks</label>
                <input id="remarks"
                       ng-readonly="!item.uploaded"
                       ng-disabled="\$ctrl.ngDisabled || !item.uploaded"
                       type="text"
                       ng-model="item.remarks"
                       name="remarks"
                       ng-blur="\$ctrl.updateRemark(\$event, item)"
                       class="file-upload__remarks" />
              </div>
              <button
                       class="btn btn-danger"
                       name="cancel"
                       type="button"
                       ng-click="\$ctrl.deleteImage(\$event, item)"
                       ng-disabled="!item.id || \$ctrl.ngDisabled"
                       ng-if="!\$ctrl.readonly && !\$ctrl.ngDisabled">
                Cancel
              </button>
            </div>
        </li>
    </ol>
    <file-upload-new
            ng-if="!\$ctrl.readonly && (\$ctrl.ngModel.\$modelValue || []).length < \$ctrl.maxFiles"
            on-files-added="\$ctrl.addFiles(files)"
            ng-disabled="\$ctrl.ngDisabled"
            validate="\$ctrl.validate"
            max-size="\$ctrl.maxSize"
            multiple="\$ctrl.maxFiles > 1"
            enable-webcam="\$ctrl.enableWebcam"
    >
    </file-upload-new>

  <validator condition="!\$ctrl.exceededFileLimit()" ></validator>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/file-upload/file-upload.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;